import { Component, OnInit } from '@angular/core';
import { SportTreeSelectionContainerComponent } from '../../sport-tree-selection-container/sport-tree-selection-container.component';

@Component({
  selector: 'app-sport-tree-selection-container-mobile',
  templateUrl: './sport-tree-selection-container-mobile.component.html',
  styleUrls: ['./sport-tree-selection-container-mobile.component.less']
})
export class SportTreeSelectionContainerMobileComponent extends SportTreeSelectionContainerComponent {

}
